export default __webpack_public_path__ + "static/media/intro5.d1027594.mp3";